import moment from "moment";
import {
  TableCellType,
  TableHeader,
} from "../../../../components/custom-table/table";
import {
  AuthLetter,
  Authorization,
} from "../../../../data-model/AuthorizationModel";

export enum AuthLettersTableKeys {
  Description = "description",
  Date = "date",
  View = "view",
}

export const AuthLettersTableColumnsKeys: TableHeader[] = [
  {
    label: "Date Created",
    key: AuthLettersTableKeys.Date,
    order: 1,
    width: 10,
    type: TableCellType.STRING,
  },
  {
    label: "Document Name",
    key: AuthLettersTableKeys.Description,
    order: 2,
    width: 83,
    type: TableCellType.STRING,
  },
  {
    label: "",
    key: AuthLettersTableKeys.View,
    order: 3,
    width: 7,
    type: TableCellType.COLORED_TEXT,
  },
];

export const generateAuthLettersTableData = (data: Authorization) => {
  const authorizationEntries: AuthLetter[] = data?.entries ?? [];
  const tableRows: any[] = [];

  authorizationEntries.forEach((authLetter: AuthLetter) => {
    const date = authLetter?.date
      ? moment(authLetter.date).format("MM/DD/YYYY")
      : "";

    tableRows.push({
      [AuthLettersTableKeys.Date]: date,
      [AuthLettersTableKeys.Description]: authLetter?.description || "N/A",
      [AuthLettersTableKeys.View]: {
        text: "View",
        color: "#0056D6",
        className: "text-end",
      },
      pdfPath: authLetter?.blob_path || "",
      pdfTitle: authLetter?.description || "Auth Letter",
    });
  });

  return tableRows;
};
